var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5V10.1492L3.91889 7.75061C4.29844 7.27618 4.87306 7 5.48063 7H13V5H8.86852H2ZM7.53518 3L6.12892 0.890599C5.75799 0.334202 5.13352 0 4.46482 0H2C0.89543 0 0 0.895431 0 2V3V5V12C0 13.1046 0.89543 14 2 14H3V13.9985C3.02668 13.9995 3.05356 14 3.08063 14H13.5194C14.1269 14 14.7016 13.7238 15.0811 13.2494L18.131 9.43704C18.9167 8.4549 18.2174 7 16.9597 7H15V5C15 3.89543 14.1046 3 13 3H7.53518ZM5.13148 3L4.46482 2H2V3H5.13148ZM15.9194 9H5.48063L3.08063 12H13.5194L15.9194 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpened);
export default __webpack_public_path__ + "static/media/opened.1806131c.svg";
export { ForwardRef as ReactComponent };